<div id="site" class="center-vertical d-flex flex-column mh-100vh">

  <div class="main-content bg-white d-flex align-items-center">

   <div class="container">

      <div class="row align-items-center">

        <div class="col-12 col-md-8 offset-md-2 col-xl-8 offset-xl-2">

          <div class="row align-items-center">

            <div class="col-md-8">
             
              <h1 class="mb-5">
                404 - Nicht gefunden
              </h1>

              <!-- Subheading -->
              <p class="mb-5 lead">
                 Der Link ist ungültig oder die Seite ist nicht mehr verfügbar. Bitte prüfen Sie die URL.
              </p>   

            </div>


          </div>
          <!-- / .row -->

        </div>

      </div>
      <!-- / .row -->
    </div>
    <!-- / .container -->



  </div>

</div>